const barRoutes = [
  {
    path: "/bar/zone-management",
    name: "ZoneManagement",
    component: () => import("@/components/bar/settings/zone/ZoneManagement.vue"),
  },
];
export default barRoutes;
